import { useEffect } from 'react';
import { useAuthStore } from '../store/auth';
import { useT } from '../i18n';
import { clearAuthToken, isDesktop, setAuthToken } from '../lib/desktop-bridge';

// ANX-059-followup — синхронизирует JWT panel с Rust-поллером.
// Rust подписывается на REST /conversations?status=open и рисует
// native OS-нотификации + tray badge даже когда webview hidden, чем
// `useMessageNotifier` / `useUnreadBadge` не могут заниматься в фоне
// (WKWebView throttles JS-таймеры в скрытом окне).

export function useDesktopAuthSync(): void {
  const t = useT();
  const access = useAuthStore((s) => s.session?.access ?? null);

  useEffect(() => {
    if (!isDesktop()) return;
    if (access) {
      void setAuthToken(access, {
        notification_title: t('notify.newMessage'),
        fallback_visitor: t('conversations.visitor.fallback'),
      });
    } else {
      void clearAuthToken();
    }
  }, [access, t]);
}
